import { Container, type ContainerProps } from "@mui/material";

const FullscreenContainer: React.FC<ContainerProps> = ({ children, sx, ...props }) => {
  return (
    <Container
      maxWidth={false}
      sx={{
        ...sx,
        height: "100vh",
        overflow: "auto",
      }}
      {...props}
    >
      {children}
    </Container>
  );
};

export default FullscreenContainer;
